import { StyleSheet } from "react-native";
import { theme } from "@lookiero/sty-psp-ui";
const style = () => {
    const { space1, space6 } = theme();
    return StyleSheet.create({
        container: {
            flex: 1,
            gap: space6,
            marginTop: space1,
        },
    });
};
export { style };
